import { isDateIsNowOrInFuture } from '@/utils/date.util';

import { WeekType } from '@/types/domain';

export const onImageError = (event: any) =>
  ((event.target as any).style.opacity = '0');

export const checkIsWeekAlreadyStarted = (week: WeekType) =>
  isDateIsNowOrInFuture(week?.start_utc);

export const TOKEN_LOGOUT = 'logout';

export const UNAUTHORIZED_ERROR_MESSAGE = '401';
